export default __webpack_public_path__ + "static/km-platform-7ea744c8ba7db99ca44c55b123f9800f.jpg";